import { CradleService } from '../services/cradle.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatSliderModule } from '@angular/material/slider';
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { ConfigEntry, CradleCommands, ConfigStatus } from '../constants/constants';
import { MatExpansionModule } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';
import { Subscription, Subject, debounceTime } from 'rxjs';
import { IMqttMessage } from 'ngx-mqtt';
import { Utils } from '../constants/utils';
import {NgxMatTimepickerModule} from 'ngx-mat-timepicker';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import ringPatterns from '../services/ring-patterns.json'
import scheduledRings from '../services/scheduled-rings.json'
import { RingPatterns, ScheduledRing, ScheduledRings, BellStatus } from '../constants/constants';
import { DataService } from '../services/data.service';
import { NotificationService } from '../services/notification.service';
import { SwPush } from '@angular/service-worker';
import { environment } from '../../environment/environment';
import { ApiService } from '../services/api.service';

@Component({
    selector: 'app-home',
    imports: [
        MatIconModule,
        MatButtonModule,
        MatCardModule,
        MatSliderModule,
        MatInputModule,
        FormsModule,
        MatExpansionModule,
        CommonModule,
        MatInputModule,
        MatCheckboxModule,
        NgxMatTimepickerModule,
        MatDatepickerModule,
        MatNativeDateModule
    ],
    templateUrl: './configurations.component.html',
    styleUrl: './configurations.component.scss',
    providers: [MatDatepickerModule]
})
export class ConfigurationsComponent implements OnInit, OnDestroy {
  isCradleOnline: boolean = false;
  configStatus: ConfigStatus = new ConfigStatus();
  subscriptions: Subscription[] = [];
  public CradleCommands = CradleCommands;
  ringInterval: number = 1;
  ringInterval2: number = 1;
  hasSecondaryInterval: boolean = false;
  ringCount:number = 0;
  selectedTime: string;
  selectedDate: Date = new Date();
  selectedSeconds: number = 0;
  private configChanged: Subject<ConfigEntry> = new Subject<ConfigEntry>();
  constructor(
    private notification: NotificationService,
    private cradleService: CradleService,
    private dataService: DataService,
    private swPush: SwPush,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    this.subscriptions.push(this.cradleService
      .listenToConfigStatus()
      .subscribe((message: IMqttMessage) => {
        this.configStatus = Utils.mapPayloadToConfigStatus(message.payload.toString());
        if (!this.isCradleOnline) {
          this.isCradleOnline = true;
          this.notification.success('Bell is online', 'Bell Online');
        }
      }));
      this.subscriptions.push(this.cradleService
        .listenToStatus()
        .subscribe((message: IMqttMessage) => {
          const status = Utils.mapPayloadToStatus(message.payload.toString());
          this.configStatus.isRinging = status.isRinging;
          if (!this.isCradleOnline) {
            this.isCradleOnline = true;
            this.notification.success('Bell is online','Bell Online');
          }
        }));
        setTimeout(()=>{
          this.cradleService.dispatchCommand(CradleCommands.PUBLISH_CONFIG_STATUS);
        },1000)

      this.configChanged.pipe(debounceTime(1000)).subscribe(config=>this.dispatchAction(config.command, config.value))
    }

  formatLabel(value: number): string {
    return `${value} s`;
  }



  updateConfig(command:CradleCommands, value:number){
    this.configChanged.next({command,value});
  }

  dispatchAction(command:CradleCommands, value:number){
    this.cradleService.dispatchCommand(
      command,
      value
    );
  }



  ringBell(){
    if(this.hasSecondaryInterval){
      this.cradleService.dispatchCommand(CradleCommands.CUTSOM_RING, this.ringCount, [this.ringInterval, this.ringInterval2]);
    } else {
      this.cradleService.dispatchCommand(CradleCommands.CUTSOM_RING, this.ringCount, [this.ringInterval]);
    }
  }

  openTimeFromIcon(timepicker: { open: () => void }){
    timepicker.open();
  }

  syncFromSelectedDate(){
      // Update time value to this.selectedDate from this.selectedTime
      if (this.selectedDate && this.selectedTime && this.selectedSeconds>=0 && this.selectedSeconds<=59) {
        console.log(this.selectedDate, this.selectedTime);
        const [hours, minutes] = this.selectedTime.split(':').map(Number);
        this.selectedDate.setHours(hours, minutes, this.selectedSeconds, 0);
        this.dispatchAction(CradleCommands.SYNC_RINGER_DATE_TIME,this.selectedDate.getTime());
        alert('selected Date: ' + this.selectedDate.getTime());
      } else {
        alert('Please select a valid date, time and seconds');
      }
  }

  syncFromSystemDate(){
    this.dispatchAction(CradleCommands.SYNC_RINGER_DATE_TIME,new Date().getTime());
  }

  dispatchDummyData(){
    this.dataService.ringPatterns.next(ringPatterns as RingPatterns);
    this.dataService.scheduledRings.next(Utils.dictToList<ScheduledRing>(scheduledRings as ScheduledRings));
    this.dataService.bellStatus.next({isSwinging:false} as BellStatus);

  }

  preventDecimal(event: KeyboardEvent): void{
    if( event.key === '.' || event.key === 'Decimal'){
      event.preventDefault();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub=>sub.unsubscribe());
  }

}
